"use strict";import{ClearButton as e}from"./src/ClearButton.js";import{defineElement as t}from"@spectrum-web-components/base/src/define-element.js";t("sp-clear-button",e);
//# sourceMappingURL=sp-clear-button.js.map
